import { NavLink } from 'react-router-dom';
import './Styles/Navbar.css';
import { useUrlParams } from '../Hooks/useUrlParams';

interface NavbarProps {
    onFeedDisplayClick: () => void;
}

export function Navbar({ onFeedDisplayClick }: NavbarProps) {
    const { walletAddress, sessionId } = useUrlParams();
    return (
        <nav>
            <ul>
                <li>
                    <NavLink className='nav-monitor-feed-page nav-container' to={`/?walletAddress=${walletAddress}&sessionId=${sessionId}`}>
                        <span className='nav-icon'></span>
                        <span className='nav-text'>Monitor Feed</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink className='nav-token-create nav-container' to={`/TokenCreate?walletAddress=${walletAddress}&sessionId=${sessionId}`}>
                        <span className='nav-icon'></span>
                        <span className='nav-text'>Token Create</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink className='nav-settings nav-container' to={`/Settings?walletAddress=${walletAddress}&sessionId=${sessionId}`}>
                        <span className='nav-icon'></span>
                        <span className='nav-text'>Settings</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink className='nav-erc-token-create nav-container' to={`/ErcTokenCreate?walletAddress=${walletAddress}&sessionId=${sessionId}`}>
                        <span className='nav-icon'></span>
                        <span className='nav-text'>ERCToken Create</span>
                    </NavLink>
                </li>
                <li>
                    <div className='nav-customize-feed nav-container' onClick={onFeedDisplayClick}>
                        <span className='nav-icon'></span>
                        <span className='nav-text'>Customize Feed</span>
                    </div>
                </li>
            </ul>
        </nav>
    );
}
